import { render, staticRenderFns } from "./ApplicationDetailsStatements.vue?vue&type=template&id=5f8a9ff9&"
import script from "./ApplicationDetailsStatements.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports